import { Api } from 'models/services/api';
import { DeleteIngredientItemQuery } from 'models/services/graphql';

type DataToFetch = {
  id: string;
};

const RequestQuery = `
  mutation DeleteIngredientItem($id: ID!) {
    ${DeleteIngredientItemQuery}
  }
`;

type ResponseData = {
  data: {
    deleteIngredientItem: DataToFetch
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: DataToFetch;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.deleteIngredientItem;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };
export type { DataToFetch as DeleteGqlDataToFetch }
